module.exports = __webpack_public_path__ + "img/sip.1432e25f.svg";